import { AutoCompleteDesignTokens } from '@primeuix/themes/types/autocomplete';

export const autocomplete: AutoCompleteDesignTokens = {
  colorScheme: {
    dark: {
      root: {
        borderColor: '{content.borderColor}',
        hoverBorderColor: '{surface.0}',
      },
      overlay: {
        background: '{blue.400}',
        borderColor: '{content.borderColor}',
      },
      option: {
        focusBackground: '{blue.300}',
      },
    },
  },
};
